import { Textarea } from "../../../components/form/Textarea";
import { FiPlus, FiMinus } from "react-icons/fi";

export const RetractableField = ({ fields, formData, changeData, errors }) => {
  return fields.map((field, fieldIndex) => (
    <section key={fieldIndex}>
      <section id={`retractible-${field.id}`} />
      {formData[field.controller] === true && field.component === "retractabletextarea" && (
        <Textarea
          value={formData[field.id]}
          label={field.label}
          onChange={e => changeData(e, field)}
          error={errors[field.id]}
          required={field.required}
        />
      )}
      {field.component === "retractable" && (
        <section className="retractable-checkbox">
          <section id={field.id} />
          <label className="retractable-checkbox-label">
            <span className="retractable-checkbox-label-icon">
              {formData[field.id] === false ? <FiPlus /> : <FiMinus />}
            </span>
            <p className="retractable-checkbox-label-name">{field.label}</p>
            <input
              type="checkbox"
              value={formData[field.id]}
              checked={formData[field.id]}
              onChange={() => changeData(!formData[field.id], field)}
            />
            <div className="retractable-checkbox-box" />
          </label>
        </section>
      )}
    </section>
  ));
};
